import {
    SiSpotify,
    SiTidal,
    SiBandcamp,
    SiDeezer,
    SiBandsintown,
    SiSoundcloud,
    SiApple
} from '@icons-pack/react-simple-icons';
import { Facebook, Instagram, Disc3 } from 'lucide-react';
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from '@/components/ui/tooltip';
import { toUrl } from '@/lib/utils';
import type { NavItem } from '@/types';

const socialNavItems: NavItem[] = [
    {
        title: 'Instagram',
        href: 'https://www.instagram.com/eivindaarset',
        icon: Instagram,
    },
    {
        title: 'Facebook',
        href: 'https://www.facebook.com/eivindaarset',
        icon: Facebook,
    },
    {
        title: 'Qobuz',
        href: 'https://www.qobuz.com/us-en/interpreter/eivind-aarset/35024',
        icon: Disc3,
    },
    {
        title: 'Bandcamp',
        href: 'https://eivindaarset.bandcamp.com',
        icon: SiBandcamp,
    },
    {
        title: 'Spotify',
        href: 'https://open.spotify.com/artist/0VqQFqLcy0bBMPDnKB25vC',
        icon: SiSpotify,
    },
    {
        title: 'Tidal',
        href: 'https://tidal.com/artist/30366',
        icon: SiTidal,
    },
    {
        title: 'Deezer',
        href: 'https://www.deezer.com/us/artist/76061',
        icon: SiDeezer,
    },
    {
        title: 'Bandsintown',
        href: 'https://www.bandsintown.com/a/122716-eivind-aarset',
        icon: SiBandsintown,
    },
    {
        title: 'Soundcloud',
        href: 'https://soundcloud.com/eivind-aarset',
        icon: SiSoundcloud,
    },
    {
        title: 'Apple Music',
        href: 'https://music.apple.com/us/artist/eivind-aarset/14739036',
        icon: SiApple,
    }
];

export default function Footer() {
    return (
        <div className="mx-auto flex w-full max-w-7xl flex-col items-center pt-4 pb-8 overflow-hidden">
            <div className="p-2 text-muted">© Eivind Aarset 2026</div>
            <div className="my-2 h-0.5 w-full bg-linear-to-r from-background via-border to-background"></div>
            <div className="flex">
                {socialNavItems.map((item) => (
                    <TooltipProvider key={item.title} delayDuration={0}>
                        <Tooltip>
                            <TooltipTrigger>
                                <a
                                    href={toUrl(item.href)}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="group inline-flex h-9 w-9 items-center justify-center rounded-md bg-transparent p-0 text-sm font-medium text-accent-foreground ring-offset-background transition-colors hover:bg-accent hover:text-accent-foreground focus-visible:ring-10 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50"
                                >
                                    <span className="sr-only">
                                        {item.title}
                                    </span>
                                    {item.icon && (
                                        <item.icon className="size-5 opacity-80 group-hover:opacity-100" />
                                    )}
                                </a>
                            </TooltipTrigger>
                            <TooltipContent>
                                <p>{item.title}</p>
                            </TooltipContent>
                        </Tooltip>
                    </TooltipProvider>
                ))}
            </div>
        </div>
    );
}
